export type StockSymbol = string;

export enum QuoteSessionType {
  aftermarket = 'AFTER_MARKET',
  na = 'NA',
  premarket = 'PRE_MARKET',
  regular = 'REGULAR',
}

export interface QuoteDetail {
  companyName: string;
  currency: string;
  // IEX, CTA...
  delayedMinutes?: number;
  exchange: string;
  source?: string; // absent for real-time quotes
}

export interface BaseIncomingQuote {
  symbol: StockSymbol;
}

export interface InitialQuote {
  detail: QuoteDetail;
  quote?: IncomingQuote;
  symbol: string;
}

export interface ErrorQuote {
  error: string;
  symbol: StockSymbol;
}

export interface IncomingQuote extends BaseIncomingQuote {
  afterMarketPrice?: number;
  afterMarketVolume?: number;
  askPrice?: number;
  bidPrice?: number;
  change?: number;

  close?: number;
  currency?: string;
  dayHigh?: number;
  dayLow?: number;
  fiftyTwoWeekHigh?: number;
  fiftyTwoWeekLow?: number;
  // timestamp
  lastTradePrice?: number;

  lastTradeTime?: string;
  open?: number;
  percentChange?: number;
  preMarketPrice?: number;
  preMarketVolume?: number;
  previousClose?: number;
  sessionType?: QuoteSessionType;

  volume?: number;
}

// import { Quote } from '@benzinga/fission';
export interface Quote extends IncomingQuote {
  currentPrice?: string;
  currentVolume?: number;
  detail: QuoteDetail;
}

export interface DetailedQuote {
  askPrice: number;
  askSize: number;
  askTime: number;
  averageVolume: number;
  bidPrice: number;
  bidSize: number;
  bidTime: number;
  bzExchange: string;
  change: number;
  changePercent: number;
  description: string;
  dividendYield: number;
  dxSymbol: StockSymbol;
  error?: string;
  ethPrice: number;
  ethTime: number;
  ethVolume: number;
  exchange: string;
  fiftyDayAveragePrice: number;
  fiftyTwoWeekHigh: number;
  fiftyTwoWeekLow: number;
  forwardPE: number;
  high: number;
  industry: string;
  isoExchange: string;
  lastTradePrice: number;
  lastTradeTime: number;
  low: number;
  marketCap: number;
  name: string;
  open: number;
  payoutRatio: number;
  pe: number;
  previousClosePrice: number;
  sector: string;
  sharesFloat: number;
  sharesOutstanding: number;
  size: number;
  symbol: StockSymbol;
  type: string;
  volume: number;
}
